<template>
  <div style="display: grid; place-content: center; height: 100vh; width: 100vw;">
    <Field />
  </div>
</template>

<script>
import Field from '@/components/Field.vue'
export default {
  name: 'Admin',
  components: {
    Field
  },
  data () {
    return {
      manage: false
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.admin{
  margin-top: 100px;
}
</style>
